module.exports = __webpack_public_path__ + "img/krzysztof-kazmierczak.da5f3d30.png";